import React, { useEffect, useState } from "react";
import HeroSection from "../../components/HeroSection";
import headerImageHome from "../../assets/heroImages/slide-bg01.jpg";
import headerImageChiSiamo from "../../assets/heroImages/ChiSiamo.jpg";
import headerImageCosaFacciamo from "../../assets/heroImages/Cosa facciamo.jpg";
import headerImageProdotti from "../../assets/heroImages/Prodotti.jpg";
import headerImageLavoraConNoi from "../../assets/heroImages/LavoraConNoi.jpg";
import headerImagePerChi from "../../assets/heroImages/PerChi.jpg";
import headerImageContatti from "../../assets/heroImages/Contatti.jpeg";
import MinimalSection from "../../components/MinimalSection";
import ContactForm from "../../components/ContactForm";
import { Helmet } from "react-helmet";


function HomePage() {

  const titoloHome = <> 
    Costruiamo insieme la tua     
    <br /> 
    protezione, passo dopo passo 
  </>
  const titoloChiSiamo = <>Nati per proteggere, <br /> cresciuti per far evolvere</>;

  const titoloCosaFacciamo = <>Soluzioni su misura <br /> per ciò che conta davvero</>;
  const descrizioneCosaFacciamo= <>
    <span>Ogni persona ha una storia diversa, priorità uniche e un modo tutto suo di vedere il futuro. </span>
    <span>Ecco perché non ti offriamo formule preconfezionate, ma percorsi pensati per proteggere ciò che per te ha davvero valore: la tua famiglia, il tuo lavoro, i tuoi sogni.</span> <br />
    <span>Con Carefidelity, la protezione diventa personale.</span> <br />
    <span>Ascoltiamo, analizziamo, costruiamo insieme.</span>
  </>

  const descrizioneProdotti = <>
    <p className="font-bold">Protezione concreta, pensata per le tue priorità</p>
    <p>Non tutti hanno gli stessi bisogni. </p>
    <p>Ecco perché i nostri prodotti sono progettati per accompagnarti nelle diverse fasi della vita, con la flessibilità e la solidità che meritano le tue scelte.</p>
    <ul>
      <li className="mt-3">
        <p className="font-bold">Protezione del reddito</p>
        <p>Per tutelarti in caso di imprevisti e garantire stabilità economica a te e alla tua famiglia.</p>
      </li>
      <li className="mt-3">
        <p className="font-bold">Tutela della salute</p>
        <p>Coperture personalizzate per affrontare con serenità ogni evenienza, dalla prevenzione alla cura.</p>
      </li>
      <li className="mt-3">
        <p className="font-bold">Sicurezza patrimoniale</p>
        <p>Strumenti efficaci per proteggere e valorizzare ciò che hai costruito, oggi e domani.</p>
      </li>
      <li className="mt-3">
        <p className="font-bold">Futuro dei tuoi cari</p>
        <p>Piani su misura per garantire un domani sereno a chi ami di più.</p>
      </li>
    </ul>
  </>
  
  const titoloPerChi = <>
        Ogni età ha le sue sfide. <br /> 
        E le sue opportunità.
    </>
  const descrizionePerChi = <>
    <p>A 30 anni si costruisce.</p>
    <p>A 50 si protegge.</p>
    <p>A 70 si raccoglie ciò che si è seminato.</p>
    <br />
    <p>In ogni fase della vita, ci sono scelte che fanno la differenza.
      Carefidelity è al tuo fianco per aiutarti a prendere quelle giuste:
      con soluzioni personalizzate, pensate per ciò che conta davvero — oggi, e domani.
    </p>
  </> 
  const titoloLavoraConNoi = <>
        Talento cerca futuro. <br /> Il nostro è un gioco di squadra.
    </>
  const titoloContatti = <>Ogni viaggio inizia da una conversazione</>;

  const handleClickForm = () => {
    const element = document.querySelector('#contact-form');
    element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div>
      <Helmet>
        <title>Carefidelity – Protezione su Misura per la Tua Serenità e Sicurezza Personale</title>
        <meta name="description" content="Scopri Carefidelity: soluzioni concrete per proteggere persone, famiglie e patrimoni. Esperti in consulenza e gestione del rischio. Fidati dei professionisti della protezione." />
      </Helmet>
      <HeroSection 
        backgroundImg={headerImageHome} 
        title={titoloHome} 
        description="Non si tratta solo di numeri, ma di scelte che cambiano il futuro." 
        buttonName="Scopri cosa possiamo fare insieme" 
        handleClickForm={handleClickForm}
      />

      {/* CHI SIAMO */}
      <MinimalSection 
        orientation='left' 
        background='bg-neutral-50' 
        title={titoloChiSiamo}
        titleClass='text-4xl text-black' 
        description={`Siamo un gruppo di professionisti con una missione semplice: aiutare le persone a prendere decisioni consapevoli, durature, trasformative. Crediamo nella solidità, nel rispetto e nella forza delle relazioni umane. Non offriamo soluzioni da catalogo: costruiamo percorsi. Con te, su misura per te.`}
        descriptionClass='text-bg-black font-normal tracking-wide text-pretty text-black text-xl pb-16'
        imageUrl={headerImageChiSiamo}
        imgOpacity="opacity-100"
        strength='0.14'
        lerp='0.30'
        buttonClass1='hidden'
        buttonClass2='hidden'
      />


      {/* COSA FACCIAMO */}
      <HeroSection
        backgroundImg={headerImageCosaFacciamo}
        title={titoloCosaFacciamo}
        description={descrizioneCosaFacciamo}
        buttonName="Scopri le soluzioni pensate per te"
        handleClickForm={handleClickForm}
      />
      <div className="relative w-full h-lvh">
        <div className="absolute h-full w-full bg-[#fafafa] gap-10 flex justify-center items-center z-50">
          <ul className="md:w-[40%] w-full">
            <li className="mb-10">
                <h3 className="text-2xl font-bold mb-3">Crescita e Progetti:</h3>
                <p>Diamo forma ai tuoi obiettivi, unendo metodo e visione. Che tu voglia realizzare un sogno o semplicemente dormire sonni tranquilli, c’è un percorso adatto a te.</p>
            </li>
            <li className="mb-10">
                <h3 className="text-2xl font-bold mb-3">Protezione Attiva:</h3>
                <p>Tutelare ciò che hai costruito è la base per tutto il resto. Ti aiutiamo a prevedere, prevenire, proteggere.</p>
            </li>
            <li className="mb-10">
                <h3 className="text-2xl font-bold mb-3">Benessere e Cura:</h3>
                <p>La salute non è un imprevisto. È una priorità. Ti accompagniamo nella scelta di soluzioni per affrontare con serenità anche ciò che non si può prevedere.</p>
            </li>
          </ul>
        </div>
      </div>


      {/* PRODOTTI */}
      <MinimalSection 
        orientation='left' 
        background='bg-neutral-50' 
        title={"Prodotti"}
        titleClass='text-4xl text-black' 
        description={descrizioneProdotti}
        descriptionClass='tracking-wide text-pretty  pb-16'
        imageUrl={headerImageProdotti}
        imgOpacity="opacity-100"
        strength='0.14'
        lerp='0.30'
        firstButtonText="Scopri tutti i nostri prodotti"
        buttonClass1=''
        buttonClass2='hidden'
        handleClickForm={handleClickForm}
      />

      {/* PER CHI */}
      <HeroSection
        backgroundImg={headerImagePerChi}
        title={titoloPerChi}
        description={descrizionePerChi}
        buttonName="Scopri il percorso più adatto a te"
        handleClickForm={handleClickForm}
      />
      <div className="bg-[#fafafa] flex flex-col justify-center items-center pt-36 pb-10 px-10 gap-10">
        <ul className="md:w-[40%] w-full">
          <li className="mb-10">
            <h3 className="text-2xl font-bold mb-3">Per chi inizia:</h3>
            <p>Hai voglia di fare, ma vuoi evitare scelte sbagliate? Partiamo insieme con basi solide, idee chiare e un piano semplice.</p>
          </li>
          <li className="mb-10">
            <h3 className="text-2xl font-bold mb-3">Per chi cresce:</h3>
            <p>Famiglia, casa, lavoro. È il momento di mettere ordine e priorità. Ti aiutiamo a guardare avanti e decidere con lucidità.</p>
          </li>
          <li className="mb-10">
            <h3 className="text-2xl font-bold mb-3">Per chi raccoglie i frutti:</h3>
            <p>Dopo una vita di scelte, meriti tranquillità e controllo. Ti aiutiamo a trasformare ciò che hai costruito in libertà quotidiana.</p>
          </li>
        </ul>
        <div className="md:w-[50%] w-full mb-11">
          <h2 className="text-3xl font-bold mb-3">Conoscere è potere. <br /> Ma scegliere con consapevolezza lo è ancora di più</h2>
          <p>Cerchiamo persone con voglia di crescere, imparare, mettersi in gioco. Se hai spirito imprenditoriale, empatia e ambizione, qui puoi trovare il posto giusto. Non vendiamo polizze, costruiamo relazioni.</p>
        </div>
      </div>

      {/* LAVORA CON NOI */}
      <HeroSection
        backgroundImg={headerImageLavoraConNoi}
        title={titoloLavoraConNoi}
        description={
          "Cerchiamo persone con voglia di crescere, imparare, mettersi in gioco. Se hai spirito imprenditoriale, empatia e ambizione, qui puoi trovare il posto giusto. Non vendiamo polizze, costruiamo relazioni."
        }
      />

      {/* CONTATTI */}
      <MinimalSection 
        orientation='right' 
        background='bg-neutral-50' 
        title={titoloContatti}
        titleClass='text-4xl text-black' 
        description={"Compila il modulo o vieni a trovarci. Siamo qui per ascoltarti, senza fretta, senza pressioni. Solo confronto vero."}
        descriptionClass='text-bg-black font-normal tracking-wide text-pretty text-black text-xl pb-16'
        imageUrl={headerImageContatti}
        imgOpacity="opacity-100"
        strength='0.14'
        lerp='0.30'
        firstButtonText="Contattaci"
        href="#contact-form"
        buttonClass1=''
        buttonClass2='hidden'
        handleClickForm={handleClickForm}
      />
      <div className="relative w-full">
        <div className="w-full bg-[#fafafa] flex justify-center items-center md:pt-[15rem] pb-10 px-10">
          <div className="w-full xl:w-1/2 text-center text-gray-700 font-medium text-lg">
            <p className="underline mb-2">
              Con sentenza del 31 gennaio 2025, il tribunale distrettuale di Lussemburgo ha dichiarato la FWU Life InsUrance Lux S.A. in liquidazione.
            </p>
            <p className="pb-5">La stessa sentenza ha nominato liquidatore il signor Yann Baden. Sarà responsabile dell'organizzazione della liquidazione.</p>
            <p className="mb-1"><span className="underline font-bold text-black">La liquidazione non comporta la perdita totale del risparmio</span> per gli assicurati (o, eventualmente, per i loro beneficiari).
            </p>
            <p className="mb-5">Entro sei mesi dalla sentenza, il liquidatore invierà una dichiarazione di credito precompilata a tutti gli assicurati (o, se del caso, ai loro beneficiari). Questi saranno informati di tutti i dettagli pratici in tale lettera.
            </p>
            <p className="underline">Gli assicurati dovranno inviare al liquidatore una dichiarazione di credito <b className="text-black">entro il 31 gennaio 2028</b>, anche se ciò non esclude <b className="text-black">la possibilità che i primi rimborsi avvengano prima di tale data</b>.</p>
            <p className="mb-5">Il controvalore degli attivi rappresentativi sarà destinato con preferenza al rimborso dei risparmi degli assicurati, in modo equo.
            </p>
            <a className="text-blue-700" href="https://www.caa.lu/fr/consommateurs/insolvabilite-de-fwu-life-insurance-lux-sa" target="_blank" rel="noopener noreferrer">https://www.caa.lu/fr/consommateurs/insolvabilite-de-fwu-life-insurance-lux-sa</a>
            <hr className="my-10"></hr>
            <p>
              Si informa che la compagnia FWU Life Insurance Lux S.A. ha{" "}
              <b className="text-black">sospeso la commercializzazione</b> dei
            </p>
            <p>
              propri prodotti a partire{" "}
              <b className="text-black">dal 03/07/2024.</b>
            </p>
            <p className="mt-10">
              Il Tribunale lussemburghese, in data{" "}
              <b className="text-black">02/08/2024,</b> ha approvato la richiesta
              di <b className="text-black">sospensione dei pagamenti</b> della FWU
              Life Insurance Lux; tale sospensione{" "}
              <b className="text-black">potrà durare al massimo 6 mesi.</b>
            </p>
            <p className="mt-16">
              A partire dal <b className="text-black">27 settembre 2024</b>, FWU
              Life Insurance Lux S.A. (“FLL”) sta{" "}
              <b className="text-black">ripristinando</b> progressivamente il
              regolare processo di investimento.
            </p>
            <p className="mb-5">
              Di seguito l'informativa rilasciata da FWU Life in data 10 ottobre
              2024:
            </p>
            <a
              className="cursor-pointer text-blue-700 font-semibold"
              href="https://assets.ctfassets.net/2novtaen2sie/5SaI6iqDVU2KjZpLW4Pp7I/cec890acc673dd34abebbee86a83bcd3/241010_Unsolvability_letter_Policyholders_it.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Vedi Documento
            </a>
            <p className="mt-10">
              Il <b className="text-black">22 gennaio 2025</b> CAA informa che ha presentato una domanda di scioglimento e liquidazione giudiziaria contro la società presso il Tribunal d’arrondissement de Luxembourg.
            </p>
            <div className="md:px-20">
              <p className="text-black text-start text-lg sm:text-xl font-bold mt-10 mb-5 sm:mt-12 -ms-5">
                Di seguito alcuni comunicati stampa:
              </p>
              <ul className="text-start space-y-5">
                <li className="list-disc">
                  <a
                    className="text-blue-700 hover:underline"
                    href="https://www.caa.lu/uploads/documents/files/FWU_Elements_suite_liquidation_20250205.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://www.caa.lu/uploads/documents/files/FWU_Elements_suite_liquidation_20250205.pdf
                  </a>
                </li>
                <li className="list-disc">
                  <a
                    className="text-blue-700 hover:underline"
                    href="https://www.caa.lu/uploads/documents/files/FWU_Echec_plan_retablissement_20250122.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://www.caa.lu/uploads/documents/files/FWU_Echec_plan_retablissement_20250122.pdf
                  </a>
                </li>
                <li className="list-disc">
                  <a
                    className="text-blue-700 hover:underline"
                    href="https://www.ivass.it/media/comunicati/documenti/2024/ivcs679.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://www.ivass.it/media/comunicati/documenti/2024/ivcs679.pdf
                  </a>
                </li>
                <li className="list-disc">
                  <a
                    className="text-blue-700 hover:underline"
                    href="https://www.ivass.it/consumatori/azioni-tutela/vigilanza-imprese-estere/fwu/20240820_Gruppo_FWU_aggiornamenti_CAA.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://www.ivass.it/consumatori/azioni-tutela/vigilanza-imprese-estere/fwu/20240820_Gruppo_FWU_aggiornamenti_CAA.pdf
                  </a>
                </li>
                <li className="list-disc">
                  <a
                    className="text-blue-700 hover:underline"
                    href="https://www.caa.lu/fr/consommateurs/insolvabilite-de-fwu-life-insurance-lux-sa"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://www.caa.lu/fr/consommateurs/insolvabilite-de-fwu-life-insurance-lux-sa
                  </a>
                </li>
                <li className="list-disc">
                  <a
                    className="text-blue-700 hover:underline"
                    href="https://www.caa.lu/uploads/documents/files/Sursis_de_paiement_de_FWU_Life_20240802.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://www.caa.lu/uploads/documents/files/Sursis_de_paiement_de_FWU_Life_20240802.pdf
                  </a>
                </li>
                <li className="list-disc">
                  <a
                    className="text-blue-700 hover:underline"
                    href="https://www.eiopa.europa.eu/eiopa-provides-initial-information-policyholders-affected-fwu-ags-insolvency-2024-08-19_en?prefLang=it"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://www.eiopa.europa.eu/eiopa-provides-initial-information-policyholders-affected-fwu-ags-insolvency-2024-08-19_en?prefLang=it
                  </a>
                </li>
              </ul>
            </div>
            <p className="text-black text-xl mt-10 mb-5">
              <b>
                Le autorità competenti (IVASS, EIOPA e l'Autorità lussemburghese
                CAA) stanno seguendo la situazione
              </b>{" "}
              in stretto contatto tra di loro.
            </p>
            <p className="text-black text-xl mb-10">
              <b>
                Eventuali aggiornamenti e comunicati stampa sono disponibili ai
                seguenti link:
              </b>
            </p>
            <div className="md:px-20">
              <ul className="text-start space-y-5">
                <li className="list-disc">
                  <a
                    className="text-blue-700 hover:underline"
                    href="https://www.ivass.it/media/comunicati/index.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://www.ivass.it/media/comunicati/index.html
                  </a>
                </li>
                <li className="list-disc">
                  <a
                    className="text-blue-700 hover:underline"
                    href="https://www.caa.lu/fr/consommateurs/infos-consommateurs"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://www.caa.lu/fr/consommateurs/infos-consommateurs
                  </a>
                </li>
                <li className="list-disc">
                  <a
                    className="text-blue-700 hover:underline"
                    href="https://www.eiopa.europa.eu/media/news_en?prefLang=it"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://www.eiopa.europa.eu/media/news_en?prefLang=it
                  </a>
                </li>
              </ul>
            </div>
            <hr className="mb-5 mt-10"></hr>
            <div className="flex flex-col justify-center items-center space-y-2">
              <p>Per eventuali informazioni:</p>
              <a className="" href="tel:0458213155">
                Tel.: <span className="text-blue-700">045 8213155</span>
              </a>
              <a className="" href="mailto:info@carefidelity.it">
                E-mail:{" "}
                <span className="text-blue-700">info@carefidelity.it</span>
              </a>
            </div>
            <hr className="my-5"></hr>
            <p className="text-4xl font-semibold text-black mt-10 mb-5">
              Chi Siamo
            </p>
            <p>
              OBIETTIVO: analizzare le tue esigenze, proponendoti le migliori
              soluzioni per il tuo benessere e il tuo futuro.
            </p>
            <p className="mt-5">
              Care Fidelity, divisione del Gruppo Care Holding SpA, iscritta in
              sezione A del RUI al nr. A000396928, è composta da professionisti in
              grado di fornire una consulenza globale rispondendo alle tue domande
              e necessità in modo professionale, chiaro e completo.
            </p>
            <p className="mt-5">
              <b>
                PRENDERCI CURA DEL TUO BENESSERE FINANZIARIO È NELLA NOSTRA NATURA
              </b>
            </p>
            <hr className="my-5"></hr>
          </div>
        </div>
      </div>


      <section className="flex justify-center bg-[#fafafa]" id="contact-form">
        <div className='w-full lg:w-3/6'>
          <ContactForm 
            Theme='light'
            LandingName='carefidelity.it'
            Name={true}
            NameText='Nome e Cognome:'
            NameRequired={true}
            Tel={true}
            TelText='Telefono:'
            TelRequired={true}
            Email={true}
            EmailText='Email:'
            EmailRequired={true}
            provincia={true}
            provinciaText='Provincia:'
            provinciaRequired={true}
            Dropdown={true}
            DropdownRequired={true}
            DropdownItem={['Prodotti assicurativi', 'Collaborare con noi']}
            DropdownText='Interessato a:'
            SendText='Invia'
            Message={true}
            MessageText='Messaggio:'
            MessageTextRequired={false}
            ConsensoDati={true}
            ConsensoDatiRequired={true}
            ConsensoDatiText='consenso dati'
            ConsensoDatiID={1}
            Newsletter={false}
            NewsletterRequired={false}
            NewsletterText='consenso dati newsletter'
            NewsletterID={21}
            successText='Messaggio inviato con successo!'  
            successLink='/'
            errorText='Si è verificato un errore, Riprova!'
          />
        </div>
      </section>
    </div>
  );
}

export default HomePage;
